
import { defineComponent, ref } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'
import { useRoute } from 'vue-router'
import { services } from '@/services/services'
import { callApiWrapper } from '@/views/callApiWrapper'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'

const service = services.deliverySlip

export default defineComponent({
  components: {
    LoadingButton,
    DismissibleAlert,
    ModalBase
  },
  emits: {
    dismiss: () => true,
    sendSlip: () => true
  },
  setup (props, { emit }) {
    const route = useRoute()
    const isWaiting = ref(false)
    const requestError = ref<string | null>(null)

    const dismiss = () => {
      emit('dismiss')
    }

    const sendSlip = async () => {
      isWaiting.value = true
      const companyKey = route.params.companyKey as string
      const serialNo = Number.parseInt(route.params.serialNo as string)
      await callApiWrapper(requestError, async () => {
        await service.sendSlip(companyKey, serialNo)
        emit('sendSlip')
      })
      isWaiting.value = false
    }

    return {
      dismiss,
      sendSlip,
      isWaiting,
      requestError
    }
  }
})
